import { ScheduleState } from "../../../type/schedule-state";

export const clearSchedulePageDispatch = (state: ScheduleState) => {
  state.schedulePage = {
    contents: [],
    first: true,
    last: true,
    page: 0,
    totalPages: 1,
    totalElements: 0,
  };
};
